"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _constants = require("../constants");

var _IdentityProviderDefa;

var IdentityProviderDefaults = (_IdentityProviderDefa = {}, (0, _defineProperty2.default)(_IdentityProviderDefa, _constants.CERTIFICATE, ''), (0, _defineProperty2.default)(_IdentityProviderDefa, _constants.ENTITY, ''), (0, _defineProperty2.default)(_IdentityProviderDefa, _constants.SERVICE, ''), _IdentityProviderDefa);

var IdentityProvider =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(IdentityProvider, _Record);

  function IdentityProvider() {
    (0, _classCallCheck2.default)(this, IdentityProvider);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IdentityProvider).apply(this, arguments));
  }

  return IdentityProvider;
}((0, _immutable.Record)(IdentityProviderDefaults, _constants.IDENTITY_PROVIDER));

exports.default = IdentityProvider;
module.exports = exports.default;